type Func<T extends any[], R> = (...a: T) => R;

export function pipe(): <T>(x: T) => T;
export function pipe<F extends Function>(f: F): F;
export function pipe<A, T extends any[], R>(
  f1: Func<T, A>,
  f2: Func<[A], R>,
): Func<T, R>;
export function pipe<A, B, T extends any[], R>(
  f1: Func<T, A>,
  f2: Func<[A], B>,
  f3: Func<[B], R>,
): Func<T, R>;
export function pipe<A, B, C, T extends any[], R>(
  f1: Func<T, A>,
  f2: Func<[A], B>,
  f3: Func<[B], C>,
  f4: Func<[C], R>,
): Func<T, R>;
export function pipe<A, B, C, D, T extends any[], R>(
  f1: Func<T, A>,
  f2: Func<[A], B>,
  f3: Func<[B], C>,
  f4: Func<[C], D>,
  f5: Func<[D], R>,
): Func<T, R>;
export function pipe<A, B, C, D, E, T extends any[], R>(
  f1: Func<T, A>,
  f2: Func<[A], B>,
  f3: Func<[B], C>,
  f4: Func<[C], D>,
  f5: Func<[D], R>,
  f6: Func<[E], R>,
): Func<T, R>;
// ... 추가적인 오버로드를 필요에 따라 정의할 수 있습니다.

export function pipe(...fns: Function[]) {
  return (x: any) => fns.reduce((v, f) => f(v), x);
}
